export enum ChatTab {
    Home,
    CustomerService
}

export default ChatTab;
